const baseUrlLocal = "https://mern-stack-blog-backend.onrender.com";
// const baseUrlLocal = "http://localhost:9000";
// const baseUrl = process.env.REACT_APP_API_URL;
export default baseUrlLocal;
